import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { MmuUserService } from '../../auth/user-service/mmu-user.service';
import { FeatureFlagsMap, MmuFeatureFlagsService } from '../../feature-flags';
import { MmuLogger } from '../../logging';


/**
 * Data processing agreement route guard factory for Miele MOVE. Check if a DPA has been signed by the company of the user.
 *
 * @returns {CanActivateFn | CanActivateChildFn}
 *
 * @example ```typescript
 * {
 *   path: 'protected',
 *   component: ProtectedComponent,
 *   canActivate: [checkDPA()]
 * }
 * ```
 */
export function hasAcceptedDPA(): CanActivateFn | CanActivateChildFn {
  return (_, state) => {
    const featureFlagService = inject(MmuFeatureFlagsService);

    /* @deprecated FF_userOrganizationDPA: Remove this shortcut when the feature flag is removed. */
    if (!featureFlagService.isFeatureEnabled(FeatureFlagsMap.FFUserOrganizationDPA)) {
      return true;
    }

    const router = inject(Router);
    const userService = inject(MmuUserService);
    const allowNavigation = userService.isServiceUser || userService.user.dpaAccepted;

    if (allowNavigation) {
      return true;
    }

    const logger = inject(MmuLogger);
    logger.warn(`Tried to access a protected page at "${state.url}", but the DPA has not yet been accepted.`);

    return router.createUrlTree(['/user/organization/data-processing-agreement'], {
      queryParams: {
        redirect: state.url
      }
    });
  };
}
